import styled from "styled-components";

export const LayoutWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 25px;
`;

export const LayoutContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 50%;
  gap: 25px;
`;
